import { themeBorderColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { AnyValue } from '@mntn-dev/utility-types'
import type { CSSProperties, PropsWithChildren } from 'react'
import { type TestIds, getTestProps } from '../../utils'

// needed to allow dynamic row identifier for data test ids
type RowType = {
  [key: string]: AnyValue
}

type TableRowProps = PropsWithChildren<
  {
    className?: string
    onClick?: (row: RowType) => void
    style?: CSSProperties
  } & TestIds
>

const TableRow = ({
  className = '',
  children,
  onClick,
  dataTestId,
  dataTrackingId,
  style,
}: TableRowProps) => {
  return (
    <tr
      className={cn(
        'group/table-row relative',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
      style={style}
      {...getTestProps({ dataTestId, dataTrackingId })}
    >
      {children}
      <div
        className={cn(
          'absolute left-0 bottom-0 w-full h-px border-b group-last/table-row:border-transparent',
          themeBorderColorMap.muted
        )}
      />
    </tr>
  )
}

export { TableRow, type TableRowProps, type RowType }
